import { Box, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { c } from "@/theme/colorUtils";

export const MemoryConsentRoot = styled(Stack)(() => ({
  width: "100%",
  height: "100vh",
}));


export const MemoryCard = styled(Box)(() => ({
  width: "100%",
  border: `1px solid ${c.grayLight}`,
  borderRadius: 16,
  backgroundColor: c.bg,
  padding: "16px",
  boxSizing: "border-box",
  cursor: "pointer",
}));

export const MemoryCardHeader = styled(Stack)(() => ({
  width: "100%",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 8,
}));

export const MemoryCardTitle = styled(Typography)(() => ({
  fontSize: "1rem",
  fontWeight: 700,
  color: c.text01,
}));

export const MemoryCardDescription = styled(Typography)(() => ({
  fontSize: "0.875rem",
  color: c.text02,
  whiteSpace: "pre-wrap",
}));


export const GuideSection = styled(Stack)(() => ({
  width: "100%",
  gap: 4,
}));

export const GuideTitle = styled(Stack)(() => ({
  flexDirection: "row",
  alignItems: "center",
  gap: 4,
  fontSize: "0.875rem",
  fontWeight: 700,
  color: c.text02,
}));

export const GuideList = styled('ul')(() => ({
  paddingLeft: 20,
  listStyle: "disc",

}));

export const GuideText = styled('li')(() => ({
  fontSize: "0.75rem", 
  color: c.grayHardest,
  padding: 0,
}));

